(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hero-cast"] && !Shopify.designMode) return;
  try {
    /* <hero-cast>: hover/tap reactions, mouse lean on desktop, pause when scrolled away.
     Pointer moves are batched into one animation frame and only write two CSS variables. */
  (() => {
    if (customElements.get('hero-cast')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    class HeroCast extends HTMLElement {
      connectedCallback() {
        if (reduce.matches) return;
        this.stage = this.closest('[data-slide], .collection-banner, section') || this.parentElement;

        this.onReact = (event) => {
          const member = event.target.closest('.hero-cast__member');
          if (!member || member.classList.contains('is-reacting')) return;
          if (event.type === 'pointerover' && (!finePointer.matches || member.contains(event.relatedTarget))) return;
          member.classList.add('is-reacting');
          setTimeout(() => member.classList.remove('is-reacting'), 900);
        };
        this.addEventListener('pointerover', this.onReact);
        this.addEventListener('pointerdown', this.onReact);

        if (finePointer.matches && this.stage) {
          let frame = 0;
          let x = 0;
          let y = 0;
          this.onMove = (event) => {
            x = event.clientX;
            y = event.clientY;
            if (frame) return;
            frame = requestAnimationFrame(() => {
              frame = 0;
              const r = this.stage.getBoundingClientRect();
              const mx = Math.max(-1, Math.min(1, ((x - r.left) / r.width) * 2 - 1));
              const my = Math.max(-1, Math.min(1, ((y - r.top) / r.height) * 2 - 1));
              this.style.setProperty('--mx', mx.toFixed(3));
              this.style.setProperty('--my', my.toFixed(3));
            });
          };
          this.onLeave = () => {
            this.style.setProperty('--mx', '0');
            this.style.setProperty('--my', '0');
          };
          this.stage.addEventListener('pointermove', this.onMove, { passive: true });
          this.stage.addEventListener('pointerleave', this.onLeave, { passive: true });
        }

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => this.classList.toggle('is-offscreen', !entry.isIntersecting));
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.stage && this.onMove) {
          this.stage.removeEventListener('pointermove', this.onMove);
          this.stage.removeEventListener('pointerleave', this.onLeave);
        }
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('hero-cast', HeroCast);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-input')) {
    class QuantityInput extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        if (!this.input) return;
        this.addEventListener('click', this.onClick.bind(this));
        this.input.addEventListener('change', () => this.syncButtons());
        this.input.addEventListener('input', () => this.syncButtons());
        this.syncButtons();
      }

      limits() {
        const min = this.input.min === '' ? 0 : Number(this.input.min);
        const max = this.input.max === '' ? Infinity : Number(this.input.max);
        const step = Number(this.input.step) || 1;
        return { min, max, step };
      }

      onClick(event) {
        const button = event.target.closest('[data-quantity-step]');
        if (!button || button.disabled) return;
        event.preventDefault();
        const { min, max, step } = this.limits();
        const current = Number(this.input.value) || 0;
        const next = Math.min(max, Math.max(min, current + step * Number(button.dataset.quantityStep)));
        if (next === current) return;
        this.input.value = next;
        this.syncButtons();
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      syncButtons() {
        const { min, max } = this.limits();
        const value = Number(this.input.value) || 0;
        const minus = this.querySelector('[data-quantity-step="-1"]');
        const plus = this.querySelector('[data-quantity-step="1"]');
        if (minus) minus.disabled = value <= min;
        if (plus) plus.disabled = value >= max;
      }
    }

    customElements.define('quantity-input', QuantityInput);
  }
  } catch(e) { console.error(e); }
})();

})();
